import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import PdfPng from '../../Assets/Pdf.png';
import { Button } from "react-bootstrap";
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { ConfigurationApiForward } from "../../ExternalApi/ConfigurationApi"
import IntegrationWizardDots from "../IntegrationWizard/IntegrationWizardDots"

const DatasourceITGlue = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 

    useEffect(() => {
        SetReady()
        SetRepainter(!mRepainter)
      }, []); 
      
    const UpdateDatasourceSetting = (aNewValue, aIdentifier) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aNewValue

        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(props.IntegrationSettings.DatasourceSettings.Domain && props.IntegrationSettings.DatasourceSettings.ApiKey)
    }
    
    return (
        <div className="scriptitembody">

            <div className="wizardfieldname">{Translate("Domain").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue">
                <select name="Domain" value={props.IntegrationSettings.DatasourceSettings.Domain} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Domain")} className="wizardinputfield">
                    <option value="AU">Australia</option>
                    <option value="EU">Europe</option>
                    <option value="US">United States</option>
                </select>

            </div>
            <span>
                <div className="wizardfieldname">{Translate("API key").toUpperCase()} <span className="redtext">*</span></div>
                <div className="wizardfieldvalue"><input autoComplete="ITGlue.APIKey" type="text" value={props.IntegrationSettings.DatasourceSettings["ApiKey"] || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "ApiKey")} className="wizardinputfield"/></div>
            </span>

        </div>
    );
}

DatasourceITGlue.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceITGlue